import { Chip } from "../../components/ui/Chip";
import { Input } from "../../components/ui/Input";
import type { PlantNameSource } from "./types";

interface Props {
  value: string;
  currentName: string;
  originalName: string | null;
  source: PlantNameSource;
  disabled?: boolean;
  onChange: (name: string, source: PlantNameSource) => void;
}

export function PlantNameField({ value, currentName, originalName, source, disabled = false, onChange }: Props) {
  const changed = value.trim() !== currentName;
  return (
    <label className="flex flex-col gap-1.5 text-xs text-rs-light-gray">
      Plant name
      <Input
        value={value}
        maxLength={400}
        disabled={disabled}
        aria-label="Plant name"
        onChange={(e) => onChange(e.target.value, "Manual")}
      />
      <span className="flex flex-wrap items-center gap-2">
        {changed && (
          <Chip variant="warn">{source === "Map" ? "Name from the map, not saved yet" : "Not saved yet"}</Chip>
        )}
        {originalName && (
          <>
            <span>EPA name: {originalName}</span>
            <button
              type="button"
              className="bg-transparent border-none p-0 text-rs-green"
              disabled={disabled}
              onClick={() => onChange(originalName, "Manual")}
            >
              Use EPA name
            </button>
          </>
        )}
      </span>
    </label>
  );
}
